import { GivelifyFormCheckbox } from '@givelify/ui';
import { styled } from '@mui/material/styles';

export const CheckboxRow = styled('div')({
    marginTop: 35,
    marginBottom: 33,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
});

export const StyledCheckbox = styled(GivelifyFormCheckbox)({
    marginRight: 12,
}) as typeof GivelifyFormCheckbox;

export const StyledLink = styled('a')(({ theme }) => ({
    textDecoration: 'none',
    color: theme.legacy.colors?.primary || theme.legacy.palette.primary.main,
    cursor: 'pointer',
    '&:hover': {
        textDecoration: 'underline',
    },
    '&:active': {
        color:
            theme.legacy.colors?.accentDarkBlue ||
            theme.legacy.palette.primary.dark,
        textDecoration: 'underline',
    },
}));

export const AgreementText = styled('div')(({ theme }) => ({
    fontSize: 14,
    lineHeight: '24px',
    fontWeight: 600,
    color: theme.legacy.palette.label.primary,
    marginTop: -5,
}));

export const FormWrapper = styled('div')({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 16,
    '& > *': {
        gridColumn: 'span 2',
    },
});

export const Column = styled('div')({
    gridColumn: 'span 1',
});

export const NameFieldWrapper = styled('div')({
    marginBottom: 26,
});

export const NicknameFieldWrapper = styled('div')({
    marginBottom: 32,
});
